import { Card, Typography } from "@material-ui/core";
import { LoadingWidget } from "Components/index";
import { lazy, Suspense } from "react";
import useStyles from "./styles";
const Target = lazy(() => import("./common/Target"));
const Checkin = lazy(() => import("./common/Checkin"));
const Reports = lazy(() => import("./common/Reports"));

const Features = () => {
  const classes = useStyles();

  return (
    <Card className={classes.featuresForm}>
      <Typography variant="h4" className="font-20 font-semibold">
        Features
      </Typography>
      <Suspense
        fallback={
          <div style={{ textAlign: "center", padding: "5rem" }}>
            <LoadingWidget color="grey" pageLoader={true} />
          </div>
        }
      >
      <Target />
      <Checkin />
      <Reports />
      </Suspense>
    </Card>
  );
};

export default Features;
